module.exports = __webpack_public_path__ + "assets/img/9.aea6e4c0.jpg";